module.exports = __webpack_public_path__ + "static/media/sample_lmsobzones.c1ebb36c.csv";